"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _hyperLink = _interopRequireDefault(require("promo-js/lib/hyper-link"));

const StepDetails = props => {
  const {
    title,
    description,
    children,
    className,
    logoUrl,
    link
  } = props;

  const renderLogo = () => /*#__PURE__*/_react.default.createElement("div", {
    className: "step-details__logo"
  });

  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('step-details', className)
  }, logoUrl ? /*#__PURE__*/_react.default.createElement(_hyperLink.default, {
    href: logoUrl,
    link: link
  }, renderLogo()) : renderLogo(), /*#__PURE__*/_react.default.createElement("div", {
    className: "step-details__content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "step-details__title"
  }, title), description && /*#__PURE__*/_react.default.createElement("div", {
    className: "step-details__description"
  }, description), children));
};

StepDetails.propTypes = {
  title: _propTypes.default.string.isRequired,
  description: _propTypes.default.string,
  children: _propTypes.default.node,
  className: _propTypes.default.string,
  logoUrl: _propTypes.default.string,
  link: _propTypes.default.func
};
StepDetails.defaultProps = {
  description: null,
  children: null,
  className: '',
  logoUrl: null,
  link: null
};
var _default = StepDetails;
exports.default = _default;